import {BasePanel} from "./BasePanel";

export class CustomPanel extends BasePanel {
    widthValue = "";

    renderDefault() {
        return null;
    }
}
